import { castArray } from 'lodash'

/**
 * @param state
 * @return {Error|null}
 */
export function getFatalError(state) {
  return state.fatalError
}

/**
 * @param state
 * @return {Array}
 */
export function getFrames(state) {
  return castArray(state.frames || [])
}

/**
 * @param state
 * @return {Object|null}
 */
export function selectedFrame(state) {
  return state.selectedFrame
}

/**
 * @param state
 * @return {Array}
 */
export function getUploadedImages(state) {
  return state.uploadedImages
}
